/**
 * O que o painel diz quando o dado não se ajusta por ali (E203.F2, ADR-0146 §10): a prova (hash
 * da custódia, registro, código de conferência, mapas, fotografias, fecho) e o método publicado não
 * mudam, e o painel diz por quê; e oferece a saída que existe: a nota do perito na seção, registrar
 * uma limitação, outra fotografia, outro documento.
 */
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';

import type { PropsDoConteudo } from './tipos';

const t = ptBR.painelDoDado;

export type SaidaDoPainel = 'limitacao' | 'fotografias' | 'conclusao' | 'documentos';

const ANCORA: Record<SaidaDoPainel, string> = {
  limitacao: 'conclusao',
  fotografias: 'fotografias',
  conclusao: 'conclusao',
  documentos: 'documentos',
};

export function ExplicacaoDoDado({
  texto,
  saidas = [],
  comNota = false,
  abrirNota,
  acoes,
}: Pick<PropsDoConteudo, 'abrirNota' | 'acoes'> & {
  texto: string;
  saidas?: readonly SaidaDoPainel[];
  /** Oferece a nota do perito da seção (quando a seção aceita nota). */
  comNota?: boolean;
}): JSX.Element {
  return (
    <div className="space-y-sc-3" data-testid="painel-explicacao">
      <p className="text-body-sm text-fg">{texto}</p>
      <div className="flex flex-col items-start gap-sc-2">
        {comNota && abrirNota !== null ? (
          <Button
            type="button"
            size="sm"
            variant="secondary"
            onClick={() => {
              acoes.fechar();
              abrirNota();
            }}
            data-testid="painel-saida-nota"
          >
            {t.saidas.nota}
          </Button>
        ) : null}
        {saidas.map((saida) => (
          <Link
            key={saida}
            to={{ hash: ANCORA[saida] }}
            className="text-body-sm text-accent-700 underline"
            onClick={acoes.fechar}
            data-testid={`painel-saida-${saida}`}
          >
            {t.saidas[saida]}
          </Link>
        ))}
      </div>
    </div>
  );
}
